import { render, staticRenderFns } from "./AgentBase.vue?vue&type=template&id=188fd3a2&scoped=true&lang=pug&"
import script from "./AgentBase.vue?vue&type=script&lang=js&"
export * from "./AgentBase.vue?vue&type=script&lang=js&"
import style0 from "./AgentBase.vue?vue&type=style&index=0&id=188fd3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188fd3a2",
  null
  
)

export default component.exports